import type { Incident, IncidentCategory } from '../realtime/contracts';
import { getAgencyView } from './incidentDomain';
import { orderIncidentsByCreatedTimeDescending } from './incidentListQueries';

function categoryFor(incident: Incident, agencyId: string): IncidentCategory {
  const view = getAgencyView(incident, agencyId);
  if (view !== null) {
    return view.category;
  }

  return incident.isClosed ? 'Closed' : 'Open';
}

function selectByCategory(
  incidents: readonly Incident[] | undefined,
  agencyId: string,
  category: IncidentCategory,
): Incident[] {
  if (incidents == null) {
    return [];
  }

  return orderIncidentsByCreatedTimeDescending(
    incidents.filter((incident) => categoryFor(incident, agencyId) === category),
  );
}

export function selectForwardedIncidents(incidents: readonly Incident[] | undefined, agencyId: string): Incident[] {
  return selectByCategory(incidents, agencyId, 'Invited');
}

export function selectCurrentlyOpenIncidents(incidents: readonly Incident[] | undefined, agencyId: string): Incident[] {
  return selectByCategory(incidents, agencyId, 'Open');
}

export function selectRecentClosedIncidents(incidents: readonly Incident[] | undefined, agencyId: string): Incident[] {
  return selectByCategory(incidents, agencyId, 'Closed');
}

export function selectIncidentMapPoints(incidents: readonly Incident[] | undefined): Incident[] | undefined {
  return incidents?.filter((incident) => incident.isClosed === false);
}
